import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchDepartments } from '../../../../store/actions/departmentActions';
import { fetchStaff } from '../../../../store/actions/staffActions';
import { clearCreatedInventoryItem, createInventoryItem, getInventoryItemCategories } from '../../../../store/actions/inventoryActions';
import { CREATING_INVENTORY_ITEM, ERROR, SET_SUCCESS } from '../../../../store/types';
import TextField from '../../../../components/elements/form/TextField';
import TextareaField from '../../../../components/elements/form/TextareaField';
import RadioGroup from '../../../../components/elements/form/RadioGroup';
import Preloader from '../../../../components/elements/Preloader';
import AutocompleteSelect from '../../../../components/elements/form/AutocompleteSelect';
import TrashIcon from '../../../../components/elements/icons/TrashIcon';
import FileUpload from '../../../../components/elements/form/FileUpload';
import NumberField from '../../../../components/elements/form/NumberField';
import DateField from '../../../../components/elements/form/DateField';
import { Switch } from '@headlessui/react';
import PlusIcon from '../../../../components/elements/icons/PlusIcon';
import FormButton from '../../../../components/elements/form/FormButton';

const NewInventoryItem = () => {
    const [itemPayload, setItemPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});
    const inventorySelector = useSelector(state => state.inventory)
    const departmentsSelector = useSelector(state => state.departments)
    const employeesSelector = useSelector(state => state.employees)

    const variantObject = {
        name: '',
        description: '',
        cost: 0,
        serialNumber: '',
        condition: '',
        manufactureYear: '',
        doAssign: false,
        assignToType: '',
        assignee: '',
        returnDate: ''
    }

    const [itemVariants, setItemVariants] = useState([variantObject]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(fetchDepartments(0, 0))
        dispatch(fetchStaff(0, 0))
        dispatch(getInventoryItemCategories(0, 0))
        if(inventorySelector?.createdItem !== null){
            dispatch({
                type: SET_SUCCESS,
                payload: 'New inventory item created successfully!'
            })
            dispatch(clearCreatedInventoryItem())
            navigate('/user/inventory/items')
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, inventorySelector.createdItem]);

    const validateForm = () => {
        let errors = {}
        
        if(!itemPayload.name || itemPayload.name === ''){
            errors.name = true
        }
        
        if(!itemPayload.description || itemPayload.description === ''){
            errors.description = true
        }

        if(!itemPayload.category || itemPayload.category === ''){
            errors.category = true
        }

        itemVariants.forEach((variant, variantIndex) => {
            if(!variant.name || variant.name === ''){
                errors[`field-${variantIndex}-name`] = true
            }

            if(selectedCategory?.additionalVariantFields && selectedCategory?.additionalVariantFields.length > 0){
                selectedCategory.additionalVariantFields.forEach((field, fieldIndex) => {
                    const indexOfField = variant.additionalVariantFields.findIndex(vField => vField.slug === field.slug)
                    if(!field.optional && (indexOfField < 0 || variant.additionalVariantFields[indexOfField].value === '')) {
                        errors[`field-${variantIndex}-${fieldIndex}-${field.slug}`] = true
                    }
                })
            }
        })

        setValidationErrors(errors)
        console.log('form errors: ', errors)
        return errors
    }

    const [file, setFile] = useState();

    const handleUpload = async (file) => {
        console.log(file)
        dispatch({
            type: CREATING_INVENTORY_ITEM,
            payload: true
        })
        var formData = new FormData()
        formData.append('file', file.file )
        const headers = new Headers();
    
        try {
            const doUpload = await fetch(`${process.env.REACT_APP_API_URL}/files/new`, {
                method: "POST",
                headers,
                body: formData,
            });
            const response = await doUpload.json();
        
            return response
        } catch (error) {
        dispatch({
            type: ERROR,
            error,
        });
        }
    }

    const pushItem = async () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }
        const payload = {
            ...itemPayload,
            variants: itemVariants
        }

        if(file) {
            const uploaded = await handleUpload(file)
            payload.photos = [uploaded.file]
        }
        
        dispatch(createInventoryItem(payload))
    }

    const variantConditions = [
        {
            label: 'New',
            value: 'new'
        },
        {
            label: 'Used',
            value: 'used'
        },
        {
            label: 'Refurbished',
            value: 'refurbished'
        },
    ]

    const assignToTypes = [
        {
            label: 'Department',
            value: 'department',
            description: 'The item will be assigned to an entire department and would be controlled by the department head.'
        },
        {
            label: 'Employee',
            value: 'employee',
            description: 'The item will be assigned directly to an employee and will be in the care of the employee themselves'
        },
    ]


    const itemTypes = [
        {
            label: 'Deductible',
            value: 'deductible',
            description: 'Deductible items will have a stock that can be deducted during assignments and re-stocked'
        },
        {
            label: 'Non-deductible',
            value: 'non-deductible',
            description: 'These items will not have a stock and each variant will only be transferable during assignments'
        }
    ]

    const addVariant = () => {
        let temp = [...itemVariants]
        temp.push(variantObject)
        setItemVariants(temp)
    }
    
    const updateVariant = (index, field, value) => {
        let temp = [...itemVariants]
        temp[index][field] = value
        setItemVariants(temp)
    }

    useEffect(() => {
        if (!selectedCategory || !selectedCategory.additionalVariantFields) return;
    
        setItemVariants(prev => {
            const updated = [...prev];
    
            updated.forEach((variant, index) => {
                if (!Array.isArray(variant.additionalVariantFields)) {
                    variant.additionalVariantFields = selectedCategory.additionalVariantFields.map(field => ({
                        slug: field.slug,
                        value: ''
                    }));
                }
            });
    
            return updated;
        });
    }, [selectedCategory, itemVariants.length]);
    
    
    const updateVariantAdditionalField = (variantIndex, fieldIndex, value) => {
        let temp = [...itemVariants]
        temp[variantIndex].additionalVariantFields[fieldIndex] = value
        setItemVariants(temp)
    }
    
    const deleteVariant = (index) => {
        let temp = [...itemVariants]
        temp.splice(index, 1)
        setItemVariants(temp)
    }

    return (
        <>
            <div className='w-full 2xl:w-5/12 mx-auto mt-[10px]'>
                <div className='w-full'>
                    <div  className='w-full'>
                        <p className="text-sm font-[500] text-gray-600">
                            Item Details
                        </p>
                        <p className='text-xs text-gray-700 mt-2'>Please provide details of the inventory item below to create a new one.</p>
                    </div>
                    <div className='w-full'>
                        <div className='mb-4 w-full'>
                            <TextField
                                inputLabel="Item name" 
                                fieldId="document-name" 
                                inputType="text"
                                inputPlaceholder={`The name of the item`} 
                                preloadValue={itemPayload.name || ''}
                                hasError={validationErrors.name} 
                                returnFieldValue={(value)=>{setItemPayload({...itemPayload, ...{name: value}})}}
                            />
                        </div>          
                    
                        <div className='mb-4 w-full'>
                            <TextareaField
                                inputLabel="Description" 
                                fieldId="dept-description" 
                                inputType="text" 
                                inputPlaceholder={`Additional description (if needed)`} 
                                preloadValue={itemPayload.description || ''}
                                hasError={validationErrors.description} 
                                returnFieldValue={(value)=>{setItemPayload({...itemPayload, ...{description: value}})}}
                            />
                        </div> 

                        <div className='mb-4 w-full'>
                            <RadioGroup
                                inputLabel="Item type"
                                items={itemTypes} 
                                inline={false}
                                hasError={validationErrors.itemType} 
                                returnSelected={(value)=>{setItemPayload({...itemPayload, ...{itemType: value.value}})}}
                            />
                        </div>

                        <div className='mb-4 w-full'>
                            {inventorySelector.loadingCategories && 
                                <Preloader />
                            }
                            {!inventorySelector.loadingCategories && inventorySelector.categories?.categories?.length > 0 && <AutocompleteSelect
                                selectOptions={inventorySelector.categories.categories}
                                inputLabel="Select Item Category"
                                titleField="name"
                                displayImage={false}
                                imageField=""
                                preSelected=''
                                placeholderText={`Select a category`}
                                fieldId="item-category"
                                hasError={false}
                                // return id of accounts of the selected option
                                returnFieldValue={(value) => {
                                    setItemPayload({...itemPayload, ...{category: value._id}})
                                    setSelectedCategory(value)
                                }}
                            />}
                            {!inventorySelector.loadingCategories && inventorySelector.categories?.categories?.length === 0 &&
                                <p className='text-xs text-red-500 p-[10px] bg-red-50 rounded border border-red-600'>No categories created yet. Create some first before creating items</p>
                            }
                        </div>  

                        <div className='w-full pb-4'>
                            <FileUpload
                                hasError={false}
                                fieldLabel={`Item Photo`}
                                returnFileDetails={(details)=>{
                                    setFile(details)
                                }}
                                acceptedFormats={['jpeg', 'jpg', 'png']}
                            />
                            <label className='block mt-3 text-xs text-gray-600 leading-[1.4em]'>Please add a good and descriptive image of the item if required</label>
                        </div>

                        <div className='border rounded-md p-5 bg-gray-100 bg-opacity-20 mt-[40px]'>
                            <p className='text-md text-gray-700 font-medium'>Item Variants</p>
                            <p className='text-xs text-gray-500 mt-1'>Variants are every specification/type of the item. Create a single variant for items with one type.</p>

                            {itemVariants.map((variant, variantIndex)=>(
                                <div key={variantIndex} className='pt-[10px] mt-[10px] border-t mb-4'>
                                    <div className='w-full flex items-center justify-between mt-[20px] mb-[10px]'>
                                        <p className='uppercase tracking-[0.2em] text-[10px] font-[500]'>Variant {variantIndex + 1}</p>
                                        {variantIndex > 0 && <button onClick={()=>{deleteVariant(variantIndex)}} className='w-[30px] h-[30px] text-gray-500 hover:text-red-600 flex items-center justify-center bg-transparent hover:bg-gray-200 rounded transition duration-200'>
                                            <TrashIcon className={`w-5 h-5`} />                
                                        </button>}
                                    </div>
                                    <div className='mb-4 w-full'>
                                        <TextField
                                            inputLabel="Variant name" 
                                            fieldId={`variant-${variantIndex}-name`}
                                            inputType="text" 
                                            preloadValue={variant.name || ''}
                                            inputPlaceholder={`What is this variant called?`} 
                                            hasError={validationErrors[`variant-${variantIndex}-name`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'name', value)}}
                                        />
                                    </div> 
                                    <div className='mb-4 w-full'>
                                        <TextField
                                            inputLabel="Variant description" 
                                            fieldId={`variant-${variantIndex}-description`}
                                            inputType="text" 
                                            inputPlaceholder={`Additional description (if needed)`} 
                                            preloadValue={variant.name || ''}
                                            hasError={validationErrors[`variant-${variantIndex}-description`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'description', value)}}
                                        />
                                    </div> 
                                    <div className='mb-4 w-full'>
                                        <RadioGroup
                                            inputLabel="Condition"
                                            items={variantConditions} 
                                            inline={true}
                                            coverWidth={true}
                                            hasError={validationErrors[`variant-${variantIndex}-condition`]} 
                                            returnSelected={(value)=>{updateVariant(variantIndex, 'condition', value.value)}}
                                        />
                                    </div>
                                    {variant.condition !== 'new' && <div className='mb-4 w-full'>
                                        <TextField
                                            inputLabel="Year of Manufacture" 
                                            fieldId={`variant-${variantIndex}-age`}
                                            inputPlaceholder={`in what year was it manufactured`} 
                                            inputType="text" 
                                            preloadValue={variant.cost || ''}
                                            hasError={validationErrors[`variant-${variantIndex}-manufacture-year`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'manufactureYear', value)}}
                                        />
                                    </div>} 
                                    {variant.type !== 'perishable' && <div className='mb-4 w-full'>
                                        <DateField
                                            inputLabel="Expiry Date" 
                                            fieldId={`variant-${variantIndex}-age`}
                                            inputPlaceholder={`When will it expire`} 
                                            inputType="text" 
                                            preloadValue={variant.expry || ''}
                                            hasError={validationErrors[`variant-${variantIndex}-expry`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'manufactureYear', value)}}
                                        />
                                    </div>} 
                                    <div className='mb-4 w-full'>
                                        <TextField
                                            inputLabel="Serial Number (if available)" 
                                            fieldId={`variant-${variantIndex}-sn`}
                                            inputType="text" 
                                            preloadValue={variant.name || ''}
                                            hasError={validationErrors[`variant-${variantIndex}-sn`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'serialNumber', value)}}
                                        />
                                    </div> 
                                    <div className='mb-4 w-full'>
                                        <NumberField
                                            inputLabel="Item Cost" 
                                            fieldId={`variant-${variantIndex}-cost`}
                                            inputPlaceholder={`How much did ths tem cost?`} 
                                            inputType="text" 
                                            preloadValue={variant.cost || ''}
                                            hasError={validationErrors[`variant-${variantIndex}-cost`]} 
                                            returnFieldValue={(value)=>{updateVariant(variantIndex, 'cost', value)}}
                                        />
                                    </div> 

                                    {selectedCategory && selectedCategory.additionalVariantFields && selectedCategory.additionalVariantFields.length > 0 && 
                                        selectedCategory.additionalVariantFields.map((field, fieldIndex) => {
                                            const fieldData = itemVariants[variantIndex]?.additionalVariantFields?.[fieldIndex];

                                            return (
                                                <div key={fieldIndex} className='w-full'>
                                                {/* 'date', 'textarea', 'number', 'text' */}
                                                    {field.valueType === 'text' && <div className='w-full mt-4'>
                                                        <TextField
                                                            inputLabel={field.label} 
                                                            fieldId={`variant-${variantIndex}-${field.slug}`}
                                                            inputType="text" 
                                                            preloadValue={fieldData?.value || ''}
                                                            hasError={validationErrors[`field-${variantIndex}-${fieldIndex}-${field.slug}`]} 
                                                            returnFieldValue={(value) => {
                                                                updateVariantAdditionalField(variantIndex, fieldIndex, {
                                                                    slug: field.slug,
                                                                    value: value
                                                                })}
                                                            }
                                                        />
                                                    </div>}
                                                    {field.valueType === 'textarea' && <div className='w-full mt-4'>
                                                        <TextareaField
                                                            inputLabel={field.label} 
                                                            fieldId={`variant-${variantIndex}-${field.slug}`}
                                                            inputType="text" 
                                                            preloadValue={''}
                                                            hasError={validationErrors[`field-${variantIndex}-${fieldIndex}-${field.slug}`]} 
                                                            returnFieldValue={(value) => {
                                                                updateVariantAdditionalField(variantIndex, fieldIndex, {
                                                                    slug: field.slug,
                                                                    value: value
                                                                })}
                                                            }
                                                        />
                                                    </div>}
                                                    {field.valueType === 'number' && <div className='w-full mt-4'>
                                                        <NumberField
                                                            inputLabel={field.label} 
                                                            fieldId={`variant-${variantIndex}-${field.slug}`}
                                                            inputType="text" 
                                                            preloadValue={''}
                                                            hasError={validationErrors[`field-${variantIndex}-${fieldIndex}-${field.slug}`]} 
                                                            returnFieldValue={(value) => {
                                                                updateVariantAdditionalField(variantIndex, fieldIndex, {
                                                                    slug: field.slug,
                                                                    value: value
                                                                })}
                                                            }
                                                        />
                                                    </div>}
                                                    {field.valueType === 'date' && <div className='w-full mt-4'>
                                                        <DateField
                                                            inputLabel={field.label} 
                                                            inputPlaceholder="" 
                                                            fieldId={`variant-${fieldIndex}-${field.slug}`} 
                                                            inputType="date" 
                                                            hasError={validationErrors[`field-${variantIndex}-${fieldIndex}-${field.slug}`]} 
                                                            returnFieldValue={(value) => {
                                                                updateVariantAdditionalField(variantIndex, fieldIndex, {
                                                                    slug: field.slug,
                                                                    value: new Date(value)
                                                                })}
                                                            }
                                                        />
                                                    </div>}
                                                    {field.description && field.description !== '' && <label className='block mt-1 text-xs text-gray-500'>
                                                        {field.description}
                                                    </label>}
                                                </div>
                                            )
                                        })
                                    }

                                    {itemPayload.itemType === 'non-deductible' && <div className='w-full my-4 flex gap-x-4 items-center justify-between'>
                                        <div  className='w-full'>
                                            <p className="text-sm text-gray-600">
                                                Assign this item
                                            </p>
                                            <p className='text-xs text-gray-400'>Flipping this switch allows you to instantly assign this item to an employee or department.</p>
                                        </div>
                                        <div className='w-24 flex flex-row-reverse'>
                                            <Switch
                                                checked={variant.doAssign}
                                                onChange={()=>{updateVariant(variantIndex, 'doAssign', !variant.doAssign)}}
                                                className={`${
                                                    variant.doAssign ? 'bg-vcm-purple' : 'bg-gray-200'
                                                } relative inline-flex items-center h-5 rounded-full w-10`}
                                                >
                                                {/* <span className="sr-only">Display stock levels</span> */}
                                                <span
                                                    className={`transform transition ease-in-out duration-200 ${
                                                    variant.doAssign ? 'translate-x-6' : 'translate-x-1'
                                                    } inline-block w-3 h-3 transform bg-white rounded-full`}
                                                />
                                            </Switch>
                                        </div>
                                    </div>}

                                    {variant.doAssign && <div className='w-full p-[20px] bg-gray-100 rounded-[8px]'>
                                        <div className='mt-3 w-full'>
                                            <RadioGroup
                                                inputLabel="Assignment type"
                                                items={assignToTypes} 
                                                inline={false}
                                                coverWidth={true}
                                                hasError={validationErrors[`variant-${variantIndex}-assign-to-type`]} 
                                                returnSelected={(value)=>{updateVariant(variantIndex, 'assignToType', value.value)}}
                                            />
                                        </div>

                                        {variant.assignToType === 'department' && <div className='mt-3 w-full'>
                                            <AutocompleteSelect
                                                selectOptions={departmentsSelector.departments.departments}
                                                inputLabel="Select Department"
                                                titleField="name"
                                                displayImage={false}
                                                inputPlaceholder={'Search for department'}
                                                imageField=""
                                                preSelected=''
                                                fieldId="variant-department"
                                                hasError={false}
                                                // return id of accounts of the selected option
                                                returnFieldValue={(value) => {updateVariant(variantIndex, 'assignee', value._id)}}
                                            />
                                        </div>}

                                        {variant.assignToType === 'employee' && <div className='mt-3 w-full'>
                                            <AutocompleteSelect
                                                selectOptions={employeesSelector.employees.employees}
                                                inputLabel="Select Employee"
                                                titleField="fullName"
                                                inputPlaceholder={'Search for employee'}
                                                displayImage={false}
                                                imageField=""
                                                preSelected=''
                                                fieldId="variant-employee"
                                                hasError={false}
                                                // return id of accounts of the selected option
                                                returnFieldValue={(value) => {updateVariant(variantIndex, 'assignee', value._id)}}
                                            />
                                        </div>}

                                        <div className='mt-3 w-full'>
                                            <DateField
                                                inputLabel="Return Date" 
                                                inputPlaceholder="Return date" 
                                                fieldId="date-of-return" 
                                                inputType="text" 
                                                hasError={false} 
                                                disabled={false}
                                                preloadValue={variant?.returnDate || ''}
                                                returnFieldValue={(value)=>{updateVariant(variantIndex, 'returnDate', value)}}
                                            />
                                            <label 
                                                className={`font-montserrat cursor-text bg-transparent text-xs z-10 font-outfit transition duration-200  
                                                text-gray-500 block mt-2`}>
                                                    If a return  date is required for the assignee to return this item, please provide it above.
                                            </label>
                                        </div>

                                    </div>}

                                    <div className='flex flex-row-reverse mt-[20px] pt-[20px] border-t border-gray-300'>
                                        <button onClick={()=>{addVariant()}} className='flex items-center justify-center font-[500] text-xs gap-x-[5px] border border-vcm-purple bg-vcm-light-purple bg-opacity-50 text-vcm-purple rounded p-[10px]'>
                                            <PlusIcon className={`w-5 h-5`} />
                                            Add another variant
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className='my-8 flex flex-row-reverse items-center justify-between pt-8'>
                    <div className='min-w-[200px]'>
                        <FormButton buttonLabel={`Create Inventory Item`} buttonAction={()=>{pushItem()}} processing={inventorySelector.creatingItem} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default NewInventoryItem